"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const FieldsSetupFlowController_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/controllers/FieldsSetupFlowController"));
const AssignmentMetadata_vue_1 = __importDefault(require("./AssignmentMetadata.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
const GisFilesBlockAssigment_vue_1 = __importDefault(require("./modals/GisFilesBlockAssigment.vue"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ViewZero.vue"));
let GisFilesSummaryTable = class GisFilesSummaryTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.filesSummaryStep;
        this.isAssignmentSection = '';
        this.hasBlockAssigment = false;
        this.searchParameter = '';
        this.filterFiles = [];
    }
    deployAssignmentSection(fileName) {
        if (this.isAssignmentSection === fileName)
            this.isAssignmentSection = '';
        else {
            this.isAssignmentSection = fileName;
        }
    }
    goNextStep() {
        this.hasBlockAssigment = false;
        this.$emit('goNextStep');
    }
    beforeStep() {
        this.$emit('beforeStep');
    }
    get uploadFiles() {
        if (this.searchParameter)
            return this.filterFiles;
        return this.STEP_CONTROLLER.data.files;
    }
    onSearchChange(searchParameter) {
        this.searchParameter = searchParameter;
        this.filterFiles = this.STEP_CONTROLLER.data.files.filter((file) => {
            return file.name.trim().toUpperCase().includes(searchParameter.trim().toUpperCase()) || file.extension.trim().toUpperCase().includes(searchParameter.trim().toUpperCase());
        });
    }
    get blockOptions() {
        const files = this.STEP_CONTROLLER.data.files;
        const columnSets = files.map((file) => new Set(file.metadata.map(meta => meta.columnName)));
        const commonColumns = columnSets.reduce((acc, set) => new Set([...acc].filter(column => set.has(column))));
        return Array.from(commonColumns).map(columnName => {
            var _a;
            const fileWithColumn = files.find(file => file.metadata.some(meta => meta.columnName === columnName));
            const columnValue = (_a = fileWithColumn === null || fileWithColumn === void 0 ? void 0 : fileWithColumn.metadata.find(meta => meta.columnName === columnName)) === null || _a === void 0 ? void 0 : _a.columnValue;
            return {
                name: columnName,
                value: columnValue
            };
        });
    }
};
GisFilesSummaryTable = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { ViewZero: ViewZero_vue_1.default, GisFilesBlockAssigment: GisFilesBlockAssigment_vue_1.default, AssignmentMetadata: AssignmentMetadata_vue_1.default, ChevronRight: lucide_vue_next_1.ChevronRight, CheckCircle: lucide_vue_next_1.CheckCircle, ChevronDown: lucide_vue_next_1.ChevronDown, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon, Tag: bmk_ui_framework_1.Tag, Dropdown: floating_vue_1.Dropdown, AlertTriangle: lucide_vue_next_1.AlertTriangle, Search: bmk_ui_framework_1.Search, Button: bmk_ui_framework_1.Button, AlignHorizontalSpaceBetween: lucide_vue_next_1.AlignHorizontalSpaceBetween } })
], GisFilesSummaryTable);
exports.default = GisFilesSummaryTable;
